<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show.sync="show"
    size="sm"
    class="b-l-1"
  >
      <div class="c-sidebar-brand b-b-1">
        <CLink href="/">
            <img
                class="c-sidebar-brand-full"
                height="20" :alt="$t('affili')" src="//statics.affili.ir/storage/assets/logo/affili-base.png"
            >
            <img
                class="c-sidebar-brand-minimized"
                height="20" :alt="$t('affili')" src="//statics.affili.ir/storage/assets/logo/affili-signet.png"
            >
        </CLink>
    </div>

    <CRenderFunction v-if="abilityUpdated" flat :content-to-render="aside"/>
    <!-- <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="minimize = !minimize"
    /> -->
  </CSidebar>
</template>

<script>
import nav from './_nav'
import { mapGetters } from 'vuex'

export default {
    name: 'TheSidebar',

    data () {
        return {
            navItem: {},
            minimize: false,
            show: 'responsive',
        }
    },

    computed: {
        ...mapGetters('user', [
            'abilityUpdated'
        ]),

        aside: {
            get() {
                return this.asideFunction()
            },
            set(aside) {
                this.navItem = aside
            }
        }
    },

    watch: {
        abilityUpdated() {
            this.aside = this.asideFunction()
        }
    },

    methods: {
        asideFunction() {
            return nav.map(element => {
                element._children = this.removeHasNotPermission(element._children)

                element._children.map(child => {
                    if(child.items) {
                        child.items = this.removeHasNotPermission(child.items)
                    }

                    return child
                })

                return element
            })
        },
        removeHasNotPermission(items) {
            items = items.map(item => {
                let rule = false
                if(item.rules) {
                    Object.keys(item.rules).map(subject => {
                        rule = rule || item.rules[subject].filter(action => this.$can(action, subject)).length > 0
                    })
                }

                return !item.rules || rule ? item : false
            }).filter(item => item !== false).map(
                item => Object.assign( {}, item, { name: this.$t(item.trans) } )
            )

            return items
        }
    },

    mounted () {
        this.$root.$on('toggle-sidebar', () => {
        const sidebarOpened = this.show === true || this.show === 'responsive'
            this.show = sidebarOpened ? false : 'responsive'
        })
        this.$root.$on('toggle-sidebar-mobile', () => {
            const sidebarClosed = this.show === 'responsive' || this.show === false
            this.show = sidebarClosed ? true : 'responsive'
        })
    }
}
</script>

<style lang="scss" scoped>
.c-sidebar::v-deep {
    .c-sidebar-nav-dropdown.c-show {
        .c-sidebar-nav-dropdown-toggle::after {
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAEkElEQVR4nO2aTWhcVRTHf2c62qaxIDNpTUtw4cZAbRpQqlJEgnERcGO7cFGsK4vd2HahDf2QQUkwLlJKoYJYpYoIQlErWIVIRGvRWsWO+NGNtBSrtM1EK1SbpvN38WZ0ks7H+8p7L/r+m8D9OOf8/zlz373nXkiRIkWKFCn+t7C4A2iGAuPZbD7/BNIGYJmMs5myXt4xufoNwxSGj4zfiZJWSHpN0peShiQt9Dh/s6Tjku6t1z/adawtm8sdRtoH3APcZuJ+mb0+lCu+5Dfu2fCdAZK+ANbUNI2Y2aCH+UVgFbDXzLbW9o12HWu7fHnxu2APNjRgWrdrovdtj2FfB18ZICnHTPIAAx7NbAH2A3tqG12RB1DmUY/+6iLrc95vwHlgWU3bKS8GzGwcGK9tc00eMOjy4q8RfGWAmZWBjcDFSlMReDpIIF7IAwidDuKvCr8ZgJl9KGk5sNTMfgkShFfyACZ7NYjPKnwLAGBm00Ac5PftnOw5EsRvFYEECAqHfPthoN/DtANXJ1dtbT3MHWLbCPklP13q2VTAymHFEYsASSEPMQiQJPIQsQBJIw8RCpBE8hCRAEklDxEIkGTyEOA47AZxkJe0VNKYJFdH5jnLgLj+85LWAYcAAXkzm2w23tVOUFI30GFmR92Mjznt3wdGgJ9akQcXGSBpCc5+vx3oM7OPm41P+m9+NtxkwBRwAWe9mGg2cL6RB5drgKQ2YFGzlJqP5CGkRXC+kocQBJjP5CGgAAWUyeZOfuClmAEc2FnqeTysuj6ApMVA1swueZ0baCNUwMoyvvYyR9D9Qsepm4L4/ceW1CnpEHAJ+F3SCUl3ebERyhrwXP6b50223e14wWc3ZhYObL/Y/Ydfn5WLmK+AlbO6/gLuNLPv3dgJZSu8e6J3UKYRt+MN1k6VrxwZ6fhxSQC3m7iePMAioODWSGhngRhEuKNJX49bI6EehiIW4dcmfa4r1aGfBiMU4RWcxa8e9ro1MifH4ShEMLMzwCM4V3RVTAGDZvaOB99zhyi+DpJuBh4A2oBPK8K4xpxXhOL4RHpBJDXBJIsQWVU4qSJEei+QRBEivxlKmgiePoOSbpD0kKQOvw5j2jY3hNd9wC7gPeCtIE6TJIJXAX6u/D0X1HFSRPC8Bki6BbhQeSdU296OkyF9OLuz0VYVZIh/TQhlEZSUAcZwyFdRBvorr8Eaz0U2nCvukfNszi3GpkulgQJ90z7CnYGwzgJrmEm+avupVhMN045SzzbzcIAB+hfkco816pR0n6Tb3RgKS4DOBu3L3Uz2I4LB+nrtkvqAT4ATlZ9lU4QlwHHgzzrtLdeAKnyIkG/QPoFTFjsPtPyJhCKAmZ0DNlccV/E5HkpT4FmEHxrEUgRWACvN7EorI6E9kzOzg5I+AtbiVGuOmtm1emMlbQRuxXlgfXWGHUwqadtwrkiThfEapv1NYml5Kfqvv4ghKY9z12jAw42KF0I2lP92GGn2C/RpiSd3T65+MYx44hDAgDdxMmB9q2e2z+ZP3r2gbBtk6hScFjr4TKn3u0iCTZEiRYoUKf7b+BsYvHxWYhYYrwAAAABJRU5ErkJggg==");
        }
    }

    .c-sidebar-nav-dropdown-toggle::after {
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAEdUlEQVR4nO2aTWhcVRiGn2+SaGJ/UDNtkzCk2aVSdaNUsCoE4yLgxnbholhx0dJujC7ULFyIC2k2liIoSFVciKAE/8CiBCpaUUt1EVDpRjNJ7AxtgrVKW9NkXhd3RqbJ/Jxz5+bOjc67GTjnfD/vO+ee+51zD7TQQgsttNDC/xbW7ATqoD3Tt/2QwT7EVmBW6PhcbuYdQFEECC2ApD7gCHAb8Dnwopn97WF/GHgCGDWzb1b2ZzKZLltumwBGKiR9fCaXPRA29xW+wkHSd8CusqZxMxvzsJ8C7gCOmdlT5X0B+faPQA9VtYc9c7nsB755r0QqjJGkW7mePFT4p+pgFHgVOFre6EIewOAxz3gV0R7S7iJwHtha1nbWx4GZnQROlre5ki96yPjEq4ZQM8DMCsB+YL7YNAU820gifuQBY7qReCWEnQGY2WeSeoEtZpZrJAlv8oAKequRmCWEFgDAzJaA2MmbeGU2nz3RSNx/fUXhJCyKr7qPgWEPszdmc9mDQCGKHJomQBLIQ5MESAp5aIIASSIPMQuQNPIQowBJJA8xCZBU8hCDAEkmDyFLYVc0g7ykLZImJb3uMn7NZkCz/nlJe4AJggOTbjP7vdZ4p1JY0g4gbWanXMY3edp/CowDv9QjDw4zQNImgnp/AzBkZl/UGp/0Z34lXGbAInCBYL1YqDVwvZEHxzVAUhfQWWtKrUfyENEiuF7JQwQCrGfy0HgdkAoOM7zJHyBC8pJukrQ5jG2jAhQkfvC02ZFOD25sMC4AknokTQCXgD8knZF0t4+PaNaAnoEjZnrOw+TrK9c6R+bnz/4ZNqakG4HvgZ0ruq4Cd5nZTy5+IimF5/LTY5KNe5js7uq4eiKdHtzUQNiDrCYP0Am84Ooksr1AE0S4vUbfna5OIt0MxSxCvkaf80l15LvBGEV4k2Dxq4Rjrk7WZDschwhmlgUeJfhEV8IiMGZmHzr7cc/RH3G8HSTdDDwIdAFfFYVxxtqfCDXhFemDtrUOcOmvi5ObN97SZcZ9jib9HW1LD9zQ2fP+5csLi2uaHDEIAMkWIRYBILkixCYAJFMEr9egpA5JD0tKhw3YpLK5KnzrgOeBT4D3GgmaJBF8Bfit+Huu0cBJEcG7DpC0DbhQvCdU3r6BYIYMEVRnL9c7QYbm1wmRFEKSUsAkAfkSCsBw8TZYzRwyvQNHDY16hJyczWVHgCXPVFchqr3ALq4nX/L9jIOt5nLTTwtz3sAAw5m+7Y9XdSjdL2nQxVFUAvRUae91tPcWwcTeio6kIeBL4EzxsayJqAQ4DVyp0F53DSiDpwjqrtKxQHAsdh6HRyQSAczsHHC4GLiEb/E4mirCXQTj5yq5TAF9wE6Xy9uR7gYlZYDdBKc1p8xsucq4/UA/wQXra5XyqrMwLkupe+fyv55uNOfYL0lJ6ib41mjAIzUOLyzT2/+SseoG+hKyJ2fz069FkU8zBDDgXYIZsLfeNdvMtoF7UqZ9SlmPoWkKensmP/NjLMm20EILLbTQwn8b/wDGYjubfIFoxQAAAABJRU5ErkJggg==");
        background-size: 8px;
    }
}

@media (hover: hover), not all {
    .c-sidebar::v-deep {
        .c-sidebar-nav-link:hover.c-sidebar-nav-dropdown-toggle::after,
        :hover.c-sidebar-nav-dropdown-toggle::after {
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAEkElEQVR4nO2aTWhcVRTHf2c62qaxIDNpTUtw4cZAbRpQqlJEgnERcGO7cFGsK4vd2HahDf2QQUkwLlJKoYJYpYoIQlErWIVIRGvRWsWO+NGNtBSrtM1EK1SbpvN38WZ0ks7H+8p7L/r+m8D9OOf8/zlz373nXkiRIkWKFCn+t7C4A2iGAuPZbD7/BNIGYJmMs5myXt4xufoNwxSGj4zfiZJWSHpN0peShiQt9Dh/s6Tjku6t1z/adawtm8sdRtoH3APcZuJ+mb0+lCu+5Dfu2fCdAZK+ANbUNI2Y2aCH+UVgFbDXzLbW9o12HWu7fHnxu2APNjRgWrdrovdtj2FfB18ZICnHTPIAAx7NbAH2A3tqG12RB1DmUY/+6iLrc95vwHlgWU3bKS8GzGwcGK9tc00eMOjy4q8RfGWAmZWBjcDFSlMReDpIIF7IAwidDuKvCr8ZgJl9KGk5sNTMfgkShFfyACZ7NYjPKnwLAGBm00Ac5PftnOw5EsRvFYEECAqHfPthoN/DtANXJ1dtbT3MHWLbCPklP13q2VTAymHFEYsASSEPMQiQJPIQsQBJIw8RCpBE8hCRAEklDxEIkGTyEOA47AZxkJe0VNKYJFdH5jnLgLj+85LWAYcAAXkzm2w23tVOUFI30GFmR92Mjznt3wdGgJ9akQcXGSBpCc5+vx3oM7OPm41P+m9+NtxkwBRwAWe9mGg2cL6RB5drgKQ2YFGzlJqP5CGkRXC+kocQBJjP5CGgAAWUyeZOfuClmAEc2FnqeTysuj6ApMVA1swueZ0baCNUwMoyvvYyR9D9Qsepm4L4/ceW1CnpEHAJ+F3SCUl3ebERyhrwXP6b50223e14wWc3ZhYObL/Y/Ydfn5WLmK+AlbO6/gLuNLPv3dgJZSu8e6J3UKYRt+MN1k6VrxwZ6fhxSQC3m7iePMAioODWSGhngRhEuKNJX49bI6EehiIW4dcmfa4r1aGfBiMU4RWcxa8e9ro1MifH4ShEMLMzwCM4V3RVTAGDZvaOB99zhyi+DpJuBh4A2oBPK8K4xpxXhOL4RHpBJDXBJIsQWVU4qSJEei+QRBEivxlKmgiePoOSbpD0kKQOvw5j2jY3hNd9wC7gPeCtIE6TJIJXAX6u/D0X1HFSRPC8Bki6BbhQeSdU296OkyF9OLuz0VYVZIh/TQhlEZSUAcZwyFdRBvorr8Eaz0U2nCvukfNszi3GpkulgQJ90z7CnYGwzgJrmEm+avupVhMN045SzzbzcIAB+hfkco816pR0n6Tb3RgKS4DOBu3L3Uz2I4LB+nrtkvqAT4ATlZ9lU4QlwHHgzzrtLdeAKnyIkG/QPoFTFjsPtPyJhCKAmZ0DNlccV/E5HkpT4FmEHxrEUgRWACvN7EorI6E9kzOzg5I+AtbiVGuOmtm1emMlbQRuxXlgfXWGHUwqadtwrkiThfEapv1NYml5Kfqvv4ghKY9z12jAw42KF0I2lP92GGn2C/RpiSd3T65+MYx44hDAgDdxMmB9q2e2z+ZP3r2gbBtk6hScFjr4TKn3u0iCTZEiRYoUKf7b+BsYvHxWYhYYrwAAAABJRU5ErkJggg==");
        }
    }
}
</style>
